import { render, staticRenderFns } from "./HandleAchievementPopup.vue?vue&type=template&id=330e6208&"
import script from "./HandleAchievementPopup.vue?vue&type=script&lang=ts&"
export * from "./HandleAchievementPopup.vue?vue&type=script&lang=ts&"
import style0 from "./HandleAchievementPopup.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VBtn,VSwitch})
